<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex align-items marginBottom20">
            <div class="flex align-items marginRight10">
              <el-button size="medium" type="primary" @click="handleCreate"
                >新增</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleEdit(row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete([row])"
          style="color:  #ff001f!important"
          >删除</el-button
        >
      </template>
    </avue-crud>
    <el-dialog
      v-if="dialogVisible"
      :title="`${form.id ? '修改增值套餐' : '新增增值套餐'}`"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <avue-form ref="form" v-model="form" :option="formOption">
        <template slot="price">
          <el-input-number
            v-model="form.price"
            placeholder="请输入"
            clearable
            :min="0.01"
            :max="999999.99"
            controls-position="right"
            :precision="2"
            style="width: 90%"
          >
          </el-input-number>
          <span class="marginLeft10">元</span>
        </template>
        <template slot="linePrice">
          <el-input-number
            v-model="form.linePrice"
            placeholder="请输入"
            clearable
            :min="0.01"
            :max="999999.99"
            controls-position="right"
            :precision="2"
            style="width: 90%"
          >
          </el-input-number>
          <span class="marginLeft10">元</span>
        </template>
        <template slot="dayNum">
          <el-input-number
            v-model="form.dayNum"
            placeholder="请输入"
            clearable
            :min="1"
            :max="9999"
            controls-position="right"
            :precision="0"
            style="width: 90%"
          >
          </el-input-number>
          <span class="marginLeft10">天</span>
        </template>

        <template slot="menuForm">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            :loading="showLoadingForm"
            @click="submit(form)"
            >确认</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  packageList,
  packageAdd,
  packageDelete,
  packageUpdate,
} from "@/api/service/package";
import FormImgUpload from "@/components/formComponents/formImgUpload";
export default {
  name: "index",
  components: {
    FormImgUpload,
  },
  data() {
    return {
      searchData: {
        title: "",
        createTime: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: false,
        tip: false,
        column: [
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "售价（元）",
            prop: "price",
          },
          {
            label: "划线价（元）",
            prop: "linePrice",
          },
          {
            label: "套餐时间（天）",
            prop: "dayNum",
          },
          {
            label: "排序",
            prop: "sort",
            width: 150,
          },
          {
            label: "最后编辑时间",
            prop: "updateTime",
          },
        ],
      },

      dialogVisible: false,
      form: {
        id: "",
        avatarUrl: [],
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "名称",
            prop: "name",
            // type: "text",
            maxlength: 8,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "售价",
            prop: "price",
            type: "number",
            maxlength: 11,
            span: 16,
            row: true,
            append: "元",
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入售价",
                trigger: "blur",
              },
            ],
          },
          {
            label: "划线价",
            prop: "linePrice",
            type: "number",
            maxlength: 100,
            span: 16,
            row: true,
            append: "COM",
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入划线价",
                trigger: "blur",
              },
            ],
          },
          {
            label: "套餐时间",
            prop: "dayNum",
            type: "number",
            maxlength: 20,
            span: 16,
            maxRows: 999999,
            minRows: 1,
            // showWordLimit: true,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入套餐时间",
                trigger: "blur",
              },
            ],
          },
          {
            label: "排序",
            prop: "sort",
            type: "number",
            maxlength: 100,
            span: 16,
            row: true,
            maxRows: 999999,
            minRows: 1,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入排序",
                trigger: "blur",
              },
            ],
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      packageList({
        page: this.page.currentPage,
        size: this.page.pageSize,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 添加
    handleCreate() {
      this.form = {
        avatarUrl: [],
        id: "",
      };
      this.dialogVisible = true;
    },
    // 关闭
    handleClose() {
      let that = this;
      this.dialogVisible = false;
      setTimeout(() => {
        that.resetForm();
      }, 500);
    },
    //编辑
    async handleEdit(row) {
      console.log(row);
      this.form.id = row.id;
      this.dialogVisible = true;
      this.form = { ...row, avatarUrl: row.avatarUrl ? [row.avatarUrl] : [] };
      console.log(this.form, "this.formthis.form");
    },

    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        packageDelete({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            console.log(row, "rowrowrowrow");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },

    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          console.log(form, "formformform");
          // return
          if (form.id) {
            packageUpdate({
              ...form,
              avatarUrl: form.url && form.url.length > 0 ? form.url[0] : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                  this.showLoadingForm = false;
                } else {
                  // this.$message.error(res.msg);
                  this.showLoadingForm = false;
                  done();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          } else {
            packageAdd({
              ...form,
              avatarUrl: form.url && form.url.length > 0 ? form.url[0] : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                  this.showLoadingForm = false;
                } else {
                  // this.$message.error(res.msg);
                  this.showLoadingForm = false;
                  done();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          }
          // this.form.type = 1;
          // done()
        }
      });
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    // 限制输入框
    changeBlur(e, text, max, type) {
      // console.log(e.target.value,text)
      // console.log(isNaN(e.target.value))
      const value = e.target.value;
      if (value) {
        if (isNaN(e.target.value)) {
          e.target.value = "";
          this.form[text] = "";
        } else {
          // console.log(Number(value))
          if (Number(value) > Number(max)) {
            if (type === "integer") {
              this.form[text] = Number(max);
            } else {
              this.form[text] = Number(max).toFixed(2);
            }
          } else {
            if (type === "integer") {
              this.form[text] = Number(value);
            } else {
              this.form[text] = Number(value).toFixed(2);
            }
          }
        }
      } else {
        e.target.value = "";
        this.form[text] = "";
      }
    },
  },
};
</script>

<style scoped></style>
